/**
 * @generated SignedSource<<a5d8f70d94387356ed4f843057aba541>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type templateEditorDialog_fragment$data = {
  readonly model: {
    readonly code: string;
    readonly id: string;
    readonly iframeDesignUrl: {
      readonly largeUrl: string;
      readonly mobileUrl: string;
    };
    readonly name: string;
  } | null;
  readonly " $fragmentType": "templateEditorDialog_fragment";
};
export type templateEditorDialog_fragment$key = {
  readonly " $data"?: templateEditorDialog_fragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"templateEditorDialog_fragment">;
};

import templateEditorDialogFragment_graphql from './templateEditorDialogFragment.graphql';

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "categoryId"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "designId"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "modelID"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "refetch": {
      "connection": null,
      "fragmentPathInResult": [],
      "operation": templateEditorDialogFragment_graphql
    }
  },
  "name": "templateEditorDialog_fragment",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "id",
          "variableName": "modelID"
        }
      ],
      "concreteType": "Model",
      "kind": "LinkedField",
      "name": "model",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "code",
          "storageKey": null
        },
        {
          "alias": null,
          "args": [
            {
              "kind": "Variable",
              "name": "categoryId",
              "variableName": "categoryId"
            },
            {
              "kind": "Variable",
              "name": "designId",
              "variableName": "designId"
            }
          ],
          "concreteType": "TemplateEditorIframe",
          "kind": "LinkedField",
          "name": "iframeDesignUrl",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "largeUrl",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "mobileUrl",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "6ad1e9b064e711f990426c57cf4bbd17";

export default node;
